export const SHOW_SEARCH_RESULTS = "SHOW_SEARCH_RESULTS";
export const UPDATE_SEARCH_VALUE = "UPDATE_SEARCH_VALUE";
export const UPDATE_SEARCH_RESULTS = "UPDATE_SEARCH_RESULTS";
export const CLEAR_SEARCH_RESULTS = "CLEAR_SEARCH_RESULTS";
export const ADD_TO_MAP_FILTERS = "ADD_TO_MAP_FILTERS";
export const REMOVE_FROM_MAP_FILTERS = "REMOVE_FROM_MAP_FILTERS";
export const CLEAR_MAP_FILTERS = "CLEAR_MAP_FILTERS";
export const UPDATE_EVENT_SEARCH = "UPDATE_EVENT_SEARCH";
export const UPDATE_EVENT_TEMPLATE_SEARCH = "UPDATE_EVENT_TEMPLATE_SEARCH";
export const UPDATE_EVENT_DIALOG_TEMPLATE_SEARCH = "UPDATE_EVENT_DIALOG_TEMPLATE_SEARCH";
export const TOGGLE_LIST_PANEL_MAP_FILTER = "TOGGLE_LIST_PANEL_MAP_FILTER";
export const UPDATE_EVENTS_FILTER = "UPDATE_EVENTS_FILTER";
